import { render, staticRenderFns } from "./create-new-button.vue?vue&type=template&id=7b864a5d&scoped=true"
import script from "./create-new-button.vue?vue&type=script&lang=js"
export * from "./create-new-button.vue?vue&type=script&lang=js"
import style0 from "./create-new-button.vue?vue&type=style&index=0&id=7b864a5d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b864a5d",
  null
  
)

export default component.exports